import * as React from 'react';
import { styles } from './styles';
import { Device } from '@routes/event/guest/NewPreview';
import { DesktopSVG } from './components/TabletSVG';
import { PhoneSVG } from './components/PhoneSVG';
import { activeInnactiveRecipe } from 'utils/color';
import chroma from 'chroma-js';
import { BaseButton } from '@routes/event/create/components/BaseButton';

interface Props {
  color: string;
  device: Device;
  mobile: boolean;
  handleFilterButtonClick: React.MouseEventHandler<HTMLButtonElement>;
  handleDeviceSelect: React.MouseEventHandler<HTMLButtonElement>;
}

export class DeviceToggle extends React.PureComponent<Props> {
  render(): React.ReactNode {
    return (
      <div className={styles.deviceWrapper}>
        <div className={styles.devicesContainer(this.props.mobile)}>
          {this.props.mobile && (
            <BaseButton
              type="button"
              onClick={this.props.handleFilterButtonClick}
              className={styles.filterButton(true)}
            >
              Design
            </BaseButton>
          )}
          {this.buildDeviceItem('monitor', DesktopSVG)}
          {this.buildDeviceItem('phone', PhoneSVG)}
        </div>
      </div>
    );
  }

  private buildDeviceItem = (device: Device, Svg: React.ComponentType<any>) => {
    const colors = this.contrastFills();
    return (
      <button type="button" className={styles.deviceButton} onClick={this.props.handleDeviceSelect} value={device}>
        <Svg active={device === this.props.device} activeColor={colors.active} inactiveColor={colors.inactive} />
      </button>
    );
  };

  private contrastFills = () => {
    const bgColor = chroma(this.props.color)
      .alpha(0.6)
      .css();
    return activeInnactiveRecipe(bgColor, '#FFF', '#333');
  };
}
